export default function Footer() {
  const scrollTop = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
            <div className="lg:w-1/3">
              <a
                href="#hero"
                onClick={scrollTop}
                className="inline-flex items-center gap-2 mb-4 cursor-pointer"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                  51
                </span>
                <span className="font-heading text-lg text-foreground-900">
                  51吃瓜网
                </span>
              </a>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                51吃瓜网今日吃瓜资源聚焦台北娜娜、莫里秀、玩偶姐姐等热门网红人物，提供人物合集、最新系列专题与网红动态盘点，是全网最活跃的吃瓜爱好者聚集地。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-6">
              <div>
                <h4 className="font-medium text-foreground-900 text-sm mb-3">快速导航</h4>
                <div className="flex flex-col gap-2">
                  <a href="#hero" onClick={scrollTop} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">首页</a>
                  <a href="#index" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">人物合集</a>
                  <a href="#carousel" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">专题盘点</a>
                  <a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">热度排行</a>
                </div>
              </div>
              <div>
                <h4 className="font-medium text-foreground-900 text-sm mb-3">热门专题</h4>
                <div className="flex flex-col gap-2">
                  <a href="#index" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">台北娜娜合集</a>
                  <a href="#index" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">莫里秀全系列</a>
                  <a href="#index" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">玩偶姐姐写真</a>
                  <a href="#topics" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">话题广场</a>
                </div>
              </div>
              <div>
                <h4 className="font-medium text-foreground-900 text-sm mb-3">关于我们</h4>
                <div className="flex flex-col gap-2">
                  <a href="#about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">平台介绍</a>
                  <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
                  <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-400">
                &copy; 2024-2026 51吃瓜网今日吃瓜资源 版权所有
              </p>
              <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-400">
                <span>友情链接</span>
                <span className="text-foreground-300">合作伙伴区域</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}